import { ReactNode } from 'react'
import * as persisted from '@state/persisted'
import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { Toaster } from 'sonner'

import { SidebarProvider } from '@/components/ui/sidebar'
import { IS_DEV } from '@/env'
import { queryClient } from '@/lib/react-query'
import { Provider as ModalStateProvider } from '@/state/modals'
import { Provider as SessionProvider } from '@/state/session'

export const AppProvider = ({ children }: { children: ReactNode }) => {
  const sidebarState = persisted.get('sidebarState')
  return (
    <QueryClientProvider client={queryClient}>
      {IS_DEV && <ReactQueryDevtools initialIsOpen={false} buttonPosition="top-right" />}
      <SessionProvider>
        <ModalStateProvider>
          <Toaster
            position="top-right"
            toastOptions={{
              classNames: {
                error: 'bg-red-500 text-white',
                success: 'bg-green-500 text-white',
                warning: 'bg-yellow-500 text-white',
                info: 'bg-blue-500 text-white',
              },
            }}
          />
          <SidebarProvider defaultOpen={sidebarState}>{children}</SidebarProvider>
        </ModalStateProvider>
      </SessionProvider>
    </QueryClientProvider>
  )
}
